var React = require('react');

function CheckCircleFilled (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7.99969 0.900391C4.0527 0.900391 0.853027 4.10006 0.853027 8.04706C0.853027 11.9941 4.0527 15.1937 7.99969 15.1937C11.9467 15.1937 15.1464 11.9941 15.1464 8.04706C15.1464 4.10006 11.9467 0.900391 7.99969 0.900391Z","fill":"currentColor","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.3394 5.70699C11.5269 5.89445 11.5269 6.19837 11.3394 6.38582L7.33943 10.3858C7.15198 10.5733 6.84806 10.5733 6.66061 10.3858L4.66061 8.38582C4.47316 8.19837 4.47316 7.89445 4.66061 7.707C4.84806 7.51954 5.15198 7.51954 5.33943 7.707L7.00002 9.36758L10.6606 5.70699C10.8481 5.51954 11.152 5.51954 11.3394 5.70699Z","fill":"white","key":1})]);
}

CheckCircleFilled.defaultProps = {"width":"32","height":"33","viewBox":"0 0 16 17","fill":"none"};

module.exports = CheckCircleFilled;

CheckCircleFilled.default = CheckCircleFilled;
